import React from 'react';

const HeaderSocials = () => {
    return (
        <div className="home__socials ">
            <a href="https://www.instagram.com/lingyue_xiao/" className="home__social-link dark:text-white" target="_blank" rel="noopener noreferrer">
                <i className="fa-brands fa-instagram"></i>
            </a>
            <a href="https://github.com/CHHORNSeyha88" className="home__social-link dark:text-white" target="_blank" rel="noopener noreferrer">
                <i className="fa-brands fa-github"></i>
            </a>
            <a href="https://web.facebook.com/seyha.koko.3910829/" className="home__social-link dark:text-white" target="_blank" rel="noopener noreferrer">
                <i className="fa-brands fa-facebook"></i>
            </a>
            <a href="https://www.linkedin.com/in/chhornseyha/" className="home__social-link dark:text-white" target="_blank" rel="noopener noreferrer">
                <i className="fa-brands fa-linkedin"></i>
            </a>
            <a href="https://twitter.com/yourusername" className="home__social-link dark:text-white" target="_blank" rel="noopener noreferrer">
                <i className="fa-brands fa-twitter"></i>
            </a>
        </div>
    );
};

export default HeaderSocials;
